import React from 'react';
import { ChevronDown } from 'lucide-react';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-3 bg-white/60 backdrop-blur-md border-b border-gray-100/70" data-id="element-29">
      <div className="flex items-center gap-7" data-id="element-30">
        <div className="flex items-center gap-2 cursor-pointer group" data-id="element-31">
          {/* Magic Patterns Logo Approximation */}
          <div className="relative w-5 h-5 flex items-center justify-center" data-id="element-32">
            <div className="absolute inset-0 bg-emerald-300 rounded-md transform -rotate-12 group-hover:-rotate-6 transition-transform duration-300 opacity-80" data-id="element-33"></div>
            <div className="absolute inset-0 bg-blue-300 rounded-md transform rotate-6 group-hover:rotate-12 transition-transform duration-300 opacity-80 mix-blend-multiply" data-id="element-34"></div>
            <div className="absolute inset-0 bg-purple-300 rounded-md transform -rotate-3 group-hover:rotate-0 transition-transform duration-300 opacity-80 mix-blend-multiply" data-id="element-35"></div>
          </div>
          <span className="text-[15px] font-semibold text-gray-900 tracking-tight" data-id="element-36">
            Magic Patterns
          </span>
        </div>

        <div className="hidden md:flex items-center gap-6" data-id="element-37">
          <button className="flex items-center gap-1 text-[13.5px] font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-38">
            Use Cases <ChevronDown className="w-3.5 h-3.5 text-gray-400" data-id="element-39" />
          </button>
          <a href="#" className="text-[13.5px] font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-40">
            Enterprise
          </a>
          <a href="#" className="text-[13.5px] font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-41">
            Customers
          </a>
          <a href="#" className="text-[13.5px] font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-42">
            Pricing
          </a>
        </div>
      </div>

      <div className="flex items-center gap-4" data-id="element-43">
        <a href="#" className="text-[13.5px] font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-44">
          Login
        </a>
        <button className="bg-[#0F172A] hover:bg-black text-white px-3.5 py-1.5 rounded-md text-[13.5px] font-medium transition-all shadow-sm hover:shadow" data-id="element-45">
          Start for Free
        </button>
      </div>
    </nav>;
}